import { Link } from 'react-router-dom'
import { clsx } from 'clsx'

export default function MobileCard({ 
  children, 
  className = '', 
  onClick,
  to,
  ...props 
}) {
  // MobileCard siempre usa estilos móviles ya que está diseñado para la UI móvil
  const baseClasses = 'bg-white rounded-[24px] shadow-medium border border-pastel-pink/90 overflow-hidden transition-all duration-200 hover:shadow-strong'
  
  const Component = to ? Link : 'div'
  const componentProps = to ? { to, ...props } : { onClick, ...props }

  return (
    <Component
      className={clsx(baseClasses, className)}
      {...componentProps}
    >
      {children}
    </Component>
  )
}

export function MobileCardImage({ src, alt, className = '' }) {
  return (
    <div className={`relative w-full aspect-square overflow-hidden bg-pastel-cream ${className}`}>
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        onError={(e) => {
          e.target.src = '/placeholder-pet.svg'
        }}
      />
    </div>
  )
}

export function MobileCardContent({ children, className = '' }) {
  return (
    <div className={`p-4 ${className}`}>
      {children}
    </div>
  )
}
